import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

function SimpleModal({
    dialogTitle,
    closeCallback,
    buttons,
    children,
    className,
    titleClassName,
    ...muiStandardProps
}) {
    const [opened, setOpened] = React.useState(true);

    return (
        <Dialog open={opened} className={`wcf-ui-dialog ${className ?? ''}`} {...muiStandardProps}>
            {dialogTitle && (
                <DialogTitle>
                    <div className="wcf-ui-dialog-title">
                        <div className={`modal-title ${titleClassName || ''}`}>{dialogTitle}</div>
                    </div>
                </DialogTitle>
            )}
            {closeCallback && (
                <div
                    className="modal-close"
                    data-test-id="modal-close"
                    onClick={() => {
                        setOpened(false);
                        closeCallback();
                    }}
                >
                    <span className="stw-add" />
                </div>
            )}
            <DialogContent>{children}</DialogContent>
            {buttons && <DialogActions>{buttons}</DialogActions>}
        </Dialog>
    );
}

export default SimpleModal;
